"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Gallery = void 0;

var _react = _interopRequireDefault(require("react"));

var _bricksUtils = require("@titelmedia/bricks-utils");

var _index = require("./galleries/horizontal/index.js");

var _index2 = require("./galleries/drawer/index.js");

var _smoothScroll = require("./galleries/smooth-scroll");

var _index3 = require("./galleries/swiper/index.js");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Gallery = function Gallery(_ref) {
  var items = _ref.items,
      galleryType = _ref.galleryType;

  var getGalleryComponent = function getGalleryComponent() {
    var C;

    switch (galleryType) {
      case 'drawer':
        C = _index2.Drawer;
        break;

      case 'smooth-scroll':
        C = _smoothScroll.SmoothScroll;
        break;

      case 'swiper':
        C = _index3.Swiper;
        break;

      default:
        C = _index.Horizontal;
        break;
    }

    return C;
  };

  var GalleryComponent = getGalleryComponent();
  console.log(galleryType);
  return _react.default.createElement(_bricksUtils.WindowSizeProvider, null, _react.default.createElement(GalleryComponent, {
    items: items
  }));
};

exports.Gallery = Gallery;